import { Component, OnInit } from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { HomeService } from 'src/home/home.service';
import { PaginatorService } from 'src/home/paginator.service';
import { Fee } from 'src/models/Fee.interface';
import { CrmService } from '../services/crm.service';


@Component({
  selector: 'app-crm-list-fees',
  templateUrl: './crm-list-fees.component.html',
  styleUrls: ['./crm-list-fees.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }]
})
export class CrmListFeesComponent implements OnInit {
  fees: Fee[] = [];
  isLoading: boolean = false;
  pageSizeOptions: number[] = [10, 20, 50];
  displayedFees: Fee[] = [];
  totalFees: number = 0;
  pageIndex: number = 0;
  pageSize: number = 10;
  public noFees: boolean = false

  constructor(private crmService: CrmService) { }

  ngOnInit(): void {
    this.getFees(1);
  }
  getFees(page: number): void {
    this.isLoading = true;
    this.crmService.getListFees({}, page)
      .subscribe(
        (data: Fee[]) => {
          this.isLoading = false;
          this.fees = data;
          if (data.length === 0) {
            this.noFees = true;
          }
          this.updateDisplayedFees();
        },
        (error: any) => {
          console.error('Error fetching fees:', error);
          this.isLoading = false;
        }
      );
  }

  handlePageEvent(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updateDisplayedFees();
  }

  updateDisplayedFees(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayedFees = this.fees.slice(startIndex, endIndex);
  }

}
